/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInscriptionDatesConvocationRequestDto
 */
export interface GetInscriptionDatesConvocationRequestDto {
    /**
     * 
     * @type {number}
     * @memberof GetInscriptionDatesConvocationRequestDto
     */
    idClasse?: number;
    /**
     * 
     * @type {Date}
     * @memberof GetInscriptionDatesConvocationRequestDto
     */
    dateInscription?: Date | null;
}

/**
 * Check if a given object implements the GetInscriptionDatesConvocationRequestDto interface.
 */
export function instanceOfGetInscriptionDatesConvocationRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetInscriptionDatesConvocationRequestDtoFromJSON(json: any): GetInscriptionDatesConvocationRequestDto {
    return GetInscriptionDatesConvocationRequestDtoFromJSONTyped(json, false);
}

export function GetInscriptionDatesConvocationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInscriptionDatesConvocationRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'dateInscription': !exists(json, 'dateInscription') ? undefined : (json['dateInscription'] === null ? null : new Date(json['dateInscription'])),
    };
}

export function GetInscriptionDatesConvocationRequestDtoToJSON(value?: GetInscriptionDatesConvocationRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClasse': value.idClasse,
        'dateInscription': value.dateInscription === undefined ? undefined : (value.dateInscription === null ? null : value.dateInscription.toISOString()),
    };
}

